import { Circle, File, MessageCircle } from "react-feather";
import { getUserData} from "../../utility/Utils";


const Arciv = [{
    id:"arch",
    title:"Arsip",
    icon:<File size={20}/>,
    navLink:"/archive"
}]

const Arc = Arciv
export default Arc
